"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const SachetIcon = props => _react.default.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none"
}, props), _react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4 2H20V7.80086L19.3665 8.05041C19.0641 8.16953 18.87 8.44665 18.87 8.76C18.87 9.07335 19.0641 9.35047 19.3665 9.46959L20 9.71914V22H4V9.71914L4.63348 9.46959C4.93586 9.35047 5.13 9.07335 5.13 8.76C5.13 8.43779 4.92859 8.16229 4.64577 8.05516L4 7.81055V2ZM6 4V6.53502C6.68467 7.03538 7.13 7.84544 7.13 8.76C7.13 9.68271 6.67903 10.4822 6 10.9807V20H18V10.9807C17.321 10.4822 16.87 9.68271 16.87 8.76C16.87 7.83729 17.321 7.03778 18 6.5393V4H6Z",
  fill: "currentColor"
}));

var _default = SachetIcon;
exports.default = _default;